var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Head-list-nav"},[_c('div',{staticClass:"nav-content"},[_c('van-tabs',{on:{"click":_vm.clickTabs}},_vm._l((_vm.nav),function(item,index){return _c('van-tab',{key:index,attrs:{"title":item.title}},[_c('HeadItemTwo',{attrs:{"list":_vm.list}})],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }